// @ts-nocheck
import * as types from 'appRedux/actions/clients';

const initialState = {
  request: false,
  success: false,
  error: '',
  message: null,
  clientList: [],
  states: [],
  addClientSuccess: false,
  clientDetail: {},
  isUpdate: false,
  pagination: {
    totalPages: null,
    total: null,
    perPage: null,
    currentPage: null,
  },
  showConfirmationModal: false,
  selectedClientId: null,
};

function clientReducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.GET_ALL_CLIENTS_REQUEST:
      return {
        ...state,
        request: true,
        success: false,
      };

    case types.GET_ALL_CLIENTS_SUCCESS:
      return {
        ...state,
        request: false,
        success: true,
        clientList: action.payload.data ? action.payload.data : [],
        pagination: {
          ...state.pagination,
          totalPages: action.payload.total_pages,
          perPage: action.payload.per_page,
          total: action.payload.total,
          currentPage: action.payload.current_page,
        },
      };

    case types.ADD_NEW_CLIENTS_REQUEST:
      return {
        ...state,
        addClientSuccess: false,
      };

    case types.ADD_NEW_CLIENTS_SUCCESS: {
      const newClientList = addClient(state.clientList, action);
      return {
        ...state,
        addClientSuccess: true,
        clientList: newClientList,
      };
    }

    case types.GET_CLIENT_BY_ID_SUCCESS:
      return {
        ...state,
        clientDetail: action.payload,
      };

    case types.GET_STATES_SUCCESS:
      return {
        ...state,
        states: action.payload,
      };

    case types.UPDATE_CLIENT_BY_ID_REQUEST: {
      return {
        ...state,
        request: true,
      };
    }

    case types.OPEN_CONFIRMATION_MODAL:
      return {
        ...state,
        showConfirmationModal: true,
        selectedClientId: action.payload.clientId,
      };

    case types.CLOSE_CONFIRMATION_MODAL:
      return {
        ...state,
        showConfirmationModal: false,
        selectedClientId: null,
      };

    case types.DELETE_CLIENT_SUCCESS:
      return {
        ...state,
        clientList: state.clientList.filter(
          (client) => client.id !== action.clientId,
        ),
      };

    default: {
      return state;
    }
  }
}

const addClient = (clientList, action) => [action.data, ...clientList];

export default clientReducer;
